import { Box, DropPinTargetIcon } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';

const ZOOM_THRESHOLD = 13;
const MOBILE_BREAKPOINT = 800;

const Wrapper = styled(Box).attrs({
  position: 'absolute',
  left: '50%',
  zIndex: 1,
})<{ $visible: boolean; $sheetVisible: boolean; $isMobile: boolean }>`
  top: ${({ $sheetVisible, $isMobile, theme }) =>
    $sheetVisible
      ? 'calc((100vh - var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) - var(--drop-pin-sheet-height, 0px)) / 2 - var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))'
      : $isMobile
        ? `calc((100vh - var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) - ${theme.layout.controlBarHeight}) / 2 - var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))`
        : '50%'};
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 200ms ease-in-out;
`;

const DropPinTargetOverlay: FC = () => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const zoom = useSelector(
    (state: any) => state.appControls?.currentMapParams?.viewPortDetails?.zoom,
  );

  const isMapRoute = pathname === '/maps' || pathname === '/maps/drop-pin';
  const isDropPin = pathname === '/maps/drop-pin';
  const isMobile = (window.innerWidth || 0) <= MOBILE_BREAKPOINT;
  const isZoomedIn = zoom > ZOOM_THRESHOLD;
  const visible = isMapRoute && isZoomedIn;

  if (!isMapRoute) return null;

  return (
    <Wrapper
      $visible={visible}
      $sheetVisible={isDropPin && isMobile}
      $isMobile={isMobile}
    >
      <DropPinTargetIcon size={96} color={theme.colors.white} />
    </Wrapper>
  );
};

export default DropPinTargetOverlay;
